import client from '../../libs/client';

export default class CommunicationGateway {
    async sendCommunication(subject, body, recipients, operationId) {
        const res = await client.post('/communication/send', {
            subject,
            body,
            recipients,
            operationId,
        });
        return res;
    }
}
